<template>
  <div class="buy">
    <Header :navIndex="navIndex"></Header>
    <div class="intro">
      <div class="left">
        <img class="line" src="../assets/index/line.png" alt="" />
        <div class="title">购买流程</div>
        <div class="subTitle">您只需参与两步 其余交给我们</div>
      </div>
      <div class="right">
        <div class="gc">
          当您需要购买阁韵产品的时候，您离理想的完美木窗只有两步距离：
        </div>
        <div class="gn">
          <p v-if="this.$isMobile">
            <span class="sort">1</span>
            选择适合您房屋装修风格的木材及木色
            <span class="sort">2</span>
            签订合同
          </p>
          <p v-else>
            <span class="sort">1</span> 选择适合您房屋装修风格的木材及木色<span
              class="sort"
              style="margin-left: 90px"
              >2</span
            >
            签订合同
          </p>
          <p>其他一切产品相关问题，全部由我们为您解决！</p>
        </div>
      </div>
    </div>
    <div class="gnWrap">
      <div class="process">
        <!-- 第一行 -->
        <div class="hang">
          <div class="k" v-for="(item, index) in list1" :key="index">
            <div class="left">
              <img :src="item.image" alt="" />
              <div class="de">{{ item.title }}</div>
            </div>
            <div class="k-right">
              <img :src="item.image1" alt="" />
            </div>
          </div>
        </div>
        <!-- 第二行 -->
        <div class="hang">
          <div class="k" v-for="(item, index) in list2" :key="index">
            <div class="left">
              <img :src="item.image" alt="" />
              <div class="de">{{ item.title }}</div>
            </div>
            <div class="k-right">
              <img :src="item.image1" alt="" />
            </div>
          </div>
        </div>

        <!-- 第三行 -->
        <div class="hang">
          <div class="k" v-for="(item, index) in list3" :key="index">
            <div class="left">
              <img :src="item.image" alt="" />
              <div class="de">{{ item.title }}</div>
            </div>
            <div class="k-right">
              <img :src="item.image1" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btm">
      <div class="btmD">
        <div class="bear"><img src="../assets/buy/bear.png" alt="" /></div>
        <div class="kuang">
          <div class="cont" v-html="desc"></div>
        </div>
      </div>
    </div>
    <XFK></XFK>
    <!-- <Part5></Part5> -->
  </div>
</template>

<script>
import { buy, buyDesc } from "../api/request";
// import Part5 from "../components/Part5";
import XFK from "../components/XFK";

export default {
  components: { XFK },
  name: "buy",
  data() {
    return {
      navIndex: 5,
      list1: [],
      list2: [],
      list3: [],
      desc: "",
      list: [],
    };
  },
  mounted() {
    buy().then((res) => {
      if (res.data.code == 1) {
        console.log(res.data.data);
        this.list = res.data.data;

        this.list1 = res.data.data[0];
        this.list2 = res.data.data[1];
        this.list3 = res.data.data[2];
      }
    });
    buyDesc().then((res) => {
      if (res.data.code == 1) {
        // console.log(res.data.data);
        this.desc = res.data.data;
      }
    });
  },
  methods: {},
};
</script>

<style scoped lang="less">
.buy {
  font-family: 微软雅黑, MicrosoftYaHei;
  .intro {
    width: 1280px;
    margin: 0 auto;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    .left {
      text-align: left;
    }
    .line {
      width: 90px;
      height: 8px;
    }
    .title {
      font-size: 42px;
      font-family: 微软雅黑, MicrosoftYaHei;
      font-weight: bold;
      color: #004c31;
      margin-top: 38px;
    }
    .subTitle {
      width: 168px;
      margin-top: 24px;
      font-size: 24px;
      font-weight: 400;
      color: #004c31;
    }
    .right {
      text-align: justify;
      width: 960px;
      .gc {
        font-weight: bold;
        margin-top: 70px;
        font-size: 24px;
        color: #004c31;
        line-height: 36px;
      }
    }
    .gn {
      border-bottom: 1px dotted #f2f2f2;
      font-size: 20px;
      font-family: 微软雅黑, MicrosoftYaHei;
      font-weight: 400;
      color: #6c7a77;
      line-height: 36px;
      .sort {
        display: inline-block;
        width: 26px;
        height: 26px;
        background: #d2a33d;
        text-align: center;
        line-height: 26px;
        margin-right: 8px;
        font-weight: bold;
        border-radius: 500px;
        color: #ffffff;
      }
    }
  }
  .gnWrap {
    width: 1280px;
    margin: 0 auto;
  }
  .process {
    margin: 35px auto 0;
    .hang {
      // border: 1px solid blue;
      margin-top: 46px;
      display: flex;
      align-items: center;
      // justify-content: space-between;
      .j {
        margin-top: -25px;
        width: 20px;
        height: 29px;
      }
      .k {
        // margin-right: 50px;
        // border: 1px solid blue;
        display: flex;
        // flex-direction: column;
        align-items: center;
        color: #004c31;
        justify-content: space-between;

        .k-left {
          padding-right: 50px;
          flex-direction: column;
          display: flex;
          align-items: center;

          .de {
            margin-top: 25px;
          }

          img {
            width: 140px;
            height: 140px;
          }
        }
        .k-right {
          margin: 0 80px;
        }
        .k-right:last-child {
          // margin: 0 0;
        }
      }
    }
    padding-bottom: 100px;
  }
  .btm {
    width: 100%;
    padding: 46px 0;
    background: #f5f5f5;
    .btmD {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .kuang {
      font-size: 20px;
      font-weight: 400;
      color: #004c31;
      line-height: 40px;
      margin-left: -20px;
      width: 750px;
      height: 175px;
      background: url("../assets/buy/kuang.png") no-repeat;
      background-size: 100% 100%;
      .cont {
        margin: 30px 0 0 57px;
        text-align: left;
      }
    }
  }
}
@media screen and (max-width: 450px) {
  .buy {
    font-family: 微软雅黑, MicrosoftYaHei;
    .intro {
      padding: 0 72px;
      width: auto;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
      .left {
        width: auto;
        text-align: left;
      }
      .line {
        width: 90 * 2px;
        height: 8 * 2px;
      }
      .title {
        font-size: 42 * 2px;
        font-family: 微软雅黑, MicrosoftYaHei;
        font-weight: bold;
        color: #004c31;
        margin-top: 38 * 2px;
      }
      .subTitle {
        width: auto;
        margin-top: 24 * 2px;
        font-size: 24 * 2px;
        font-weight: 400;
        color: #004c31;
      }
      .right {
        text-align: justify;
        width: auto;
        .gc {
          font-weight: bold;
          margin-top: 70 * 2px;
          font-size: 24 * 2px;
          color: #004c31;
          line-height: unset;
        }
        .gn {
          border-bottom: 1px dotted #f2f2f2;
          font-size: 20 * 2px;
          font-family: 微软雅黑, MicrosoftYaHei;
          font-weight: 400;
          color: #6c7a77;
          text-align: left;
          line-height: unset;
          p {
            &:nth-child(2) {
              margin-left: 0 !important;
            }
          }
          .sort {
            display: inline-block;
            width: 26 * 2px;
            height: 26 * 2px;
            background: #d2a33d;
            text-align: center;
            line-height: 26 * 2px;
            margin-right: 8 * 2px;
            font-weight: bold;
            border-radius: 500px;
            color: #ffffff;
          }
        }
      }
    }

    .btm {
      width: auto;
      padding: 46px 0;
      background: #f5f5f5;
      .btmD {
        margin-left: 20px;
        display: flex;
        align-items: center;
        .bear {
          width: 195 * 2px;
          height: 245 * 2px;
          img {
            width: 195 * 2px;
            height: 245 * 2px;
          }
        }
      }
      .kuang {
        font-size: 20 * 2px;
        font-weight: 400;
        color: #004c31;
        line-height: unset;
        margin-left: -20px;
        width: 750 * 2px;
        height: auto;
        background: url("../assets/buy/kuang.png") no-repeat;
        background-size: 100% 100%;
        .cont {
          margin: 30px 0 0 57px;
          text-align: left;
        }
      }
    }
    .gnWrap {
      width: 100% !important;
      // border: 1px solid blue;
    }
    .process {
      .hang {
        display: flex;
        width: 100%;
        justify-content: center;
        // align-items: center;
        // justify-content: space-between;
        margin-top: 100px;
        .k {
          // width: 25%;
          // margin-right: 50px;
          // border: 1px solid blue;
          display: flex;
          // flex-direction: column;
          // align-items: center;
          color: #004c31;
          justify-content: space-between;

          .left {
            // padding-right: 50px;
            flex-direction: column;
            display: flex;
            align-items: center;

            .de {
              // margin-top: 25px;
            }

            img {
              width: 140 * 2px !important;
              height: 140 * 2px !important;
            }
          }
          .k-right {
            img {
              width: 50px;
              height: 70px;
            }
            // margin: 0 80px;
            margin: 0 !important;
          }
          .k-right:last-child {
            // margin: 0 0;
          }
        }
      }
      .hang:last-child {
        justify-content: left;
        margin-left: 300px;
      }
      padding-bottom: 100px !important;
    }
  }
}
</style>
